import createFetchClient, { type Client } from "openapi-fetch";
import type { components, paths } from "./schema";

export type { components, operations, paths } from "./schema";

/** The error body every endpoint returns: branch on `error.code`. */
export type ApiError = components["schemas"]["ErrorResponse"];

export interface ClientOptions {
  /** e.g. https://api.powwater.com */
  baseUrl: string;
  /** the bearer token from sign-in (better-auth, /api/auth/*) */
  token?: string;
  /** X-Client-App: the product, sent on sign-in */
  clientApp?: "admin" | "customer_app" | "customer_portal" | "driver_app" | "partner_portal" | "fleet_app";
  /** X-Company: the company slug, for phone sign-in in the customer and driver apps */
  company?: string;
  /** a custom fetch, e.g. an app's own `fetch` in tests */
  fetch?: (request: Request) => Promise<Response>;
}

/**
 * A typed client for every route in openapi.json: paths, parameters, bodies and responses are
 * checked at compile time.
 *
 *   const api = createClient({ baseUrl, token });
 *   const { data, error } = await api.GET("/v1/admin/catalog/products", { params: { query: { limit: 10 } } });
 *
 * Sign-in itself is better-auth's (/api/auth/*), outside the OpenAPI document.
 */
export function createClient(options: ClientOptions): Client<paths> {
  const headers: Record<string, string> = {};
  if (options.token) headers.authorization = `Bearer ${options.token}`;
  if (options.clientApp) headers["x-client-app"] = options.clientApp;
  if (options.company) headers["x-company"] = options.company;
  return createFetchClient<paths>({ baseUrl: options.baseUrl, headers, fetch: options.fetch });
}
